import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMoney = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Money",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12481",
			"data-name": "Path 12481",
			d: "M0,0H24V24H0Z",
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12482",
			"data-name": "Path 12482",
			d: "M5,10V8H7",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12483",
			"data-name": "Path 12483",
			d: "M5,14v2H7",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12484",
			"data-name": "Path 12484",
			d: "M17,8h2v2",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12485",
			"data-name": "Path 12485",
			d: "M17,16h2V14",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12486",
			"data-name": "Path 12486",
			d: "M20,19H4a2,2,0,0,1-2-2V7A2,2,0,0,1,4,5H20a2,2,0,0,1,2,2V17A2,2,0,0,1,20,19Z",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12487",
			"data-name": "Path 12487",
			d: "M13.768,10.232a2.5,2.5,0,1,1-3.536,0,2.5,2.5,0,0,1,3.536,0",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		})
	]
});
export default SvgMoney;
